module.exports = __webpack_public_path__ + "static/img/pattern.7e244d33.png";